import { render } from "./TasksHome.vue?vue&type=template&id=d8787532&scoped=true&ts=true&lang=pug"
import script from "./TasksHome.vue?vue&type=script&lang=ts"
export * from "./TasksHome.vue?vue&type=script&lang=ts"

import "./TasksHome.vue?vue&type=style&index=0&id=d8787532&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8787532"]])

export default __exports__